import { useEffect } from "react";

// The MyElite intake form lives on Typeform's custom domain. The data-tf-live
// embed id resolves to an incorrect URL from third-party sites, so we embed the
// real form URL directly — it renders full-size and reliably.
const FORM_URL = "https://thotis.typeform.com/Elite";

export function TypeformIntake({ email, onSubmit, height = "72vh", minHeight = 560 }) {
  useEffect(() => {
    // Best-effort: Typeform posts messages to the parent when the form is submitted.
    const handler = (event) => {
      if (typeof event.origin === "string" && event.origin.includes("typeform.com")) {
        const data = event.data;
        const type = typeof data === "string" ? data : data?.type;
        if (type && String(type).toLowerCase().includes("submit")) {
          onSubmit?.();
        }
      }
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, [onSubmit]);

  const params = new URLSearchParams({ utm_source: "MyElite" });
  if (email) params.set("email", email);
  const src = `${FORM_URL}?${params.toString()}&typeform-embed=embed-widget&embed-hide-headers=true`;

  return (
    <div
      data-testid="typeform-intake"
      className="rounded-3xl overflow-hidden border border-border bg-navy"
      style={{ width: "100%", height, minHeight }}
    >
      <iframe
        title="MyElite intake form"
        src={src}
        style={{ width: "100%", height: "100%", border: 0 }}
        allow="camera; microphone; autoplay; encrypted-media;"
      />
    </div>
  );
}
